import React from 'react';
import map_fr from '../../assets/video/fr/map_fr.mp4';
import map from '../../assets/video/amirtemur.mp4';
import './styles.css';
import { useLocation } from 'react-router-dom';

export const Player = ({ setVideoShowed }) => {
  const { pathname } = useLocation();
  const isfr = pathname.includes('fr');

  const video_src = isfr ? map_fr : map;

  return (
    <div className='player_container'>
      <video
        onEnded={() => setVideoShowed(false)}
        height='100%'
        poster={require('../../assets/map.png')}
        autoPlay
        width='100%'
        controls
      >
        <source src={video_src} type='video/mp4' />
        Your browser does not support HTML video.
      </video>
    </div>
  );
};
